import { RootState, Settings, Status } from '../types';

export const getSettingsStatus = (state: RootState): Status => state.settings.status;

export const getSettingsErrorMsg = (state: RootState): string | null => state.settings.errorMsg;

export const getSettings = (state: RootState): Settings | null => state.settings.settings;
